import React, { Component } from 'react';
import Workbook from 'react-excel-workbook';

export default class ExcelExport extends Component {
  static multiIndex(obj, is) {
    return is.length ? ExcelExport.multiIndex(obj[is[0]], is.slice(1)) : obj
  }

  static pathIndex(obj,is) {
    return ExcelExport.multiIndex(obj,is.split('.'))
  }

  render() {
    const { element, data } = this.props;
    return (
      <Workbook filename={`${data.fileName}.xlsx` || 'export.xlsx'} element={element}>
        {
          data && data.sheets && data.sheets.map((sheet, sheetIndex) => {
            return (
              <Workbook.Sheet key={`sheet_${sheetIndex}`} data={sheet.data} name={`${sheet.name}` || `List ${sheetIndex}`}>
                {
                  sheet.columns && sheet.columns.map(column => {
                    if (column.Header && column.accessor) {
                      return <Workbook.Column key={`column_${column.accessor}`} label={column.Header} value={row => ExcelExport.pathIndex(row, column.accessor)} />
                    }
                    return null;
                  })
                }
              </Workbook.Sheet>
            )
          })
        }
      </Workbook>
    );
  }
}


/** WEBPACK FOOTER **
 ** ./src/components/ExcelExport/index.js
 **/